import { map } from 'ramda';
import React, { FC } from 'react';
import styled from 'styled-components';

import { CardContent } from '@folx-types/dashboard';

import DashboardCardLink from '../DashboardCardLink';

interface IDashboardCardsProps {
	cards?: CardContent[];
	variant?: 'default' | 'minimal';
}

const DashboardCards: FC<IDashboardCardsProps> = ({ cards = [], variant = 'default' }) => {
	return map(
		(cardContent: CardContent) => (
			<DashboardCardLink key={cardContent.pathName} variant={variant} {...cardContent} />
		),
		cards
	);
};

export default styled(DashboardCards)``;
